
import _ from 'lodash'

export const name = 'ImageXAspect'

export const functionLibrary = {
    sortByBreakpointsOrder: (data, breakpointIdToOrderIndex) => _.sortBy(data, item => item.breakpoint ? breakpointIdToOrderIndex[item.breakpoint.replace('#', '')] : -1)
}